import React, { useState }  from 'react'
import axios from 'axios'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Car1 from '../../images/car1.png'
import Car2 from '../../images/car2.png'
import Car3 from '../../images/car3.png'
import { MdArrowLeft, MdArrowRight } from "react-icons/md"
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function BookDemoDriveCalendar() {
  const [demoScheduleDisplay,setDemoScheduleDisplay] = useState(false)
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  const [storeName, setStoreName] = useState('')
  const [vehicleName, setVehicleName] = useState('')
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [reservation_data1, setReservation_data1] = useState([])
  const [reservationStart, setReservationStart] = useState('')
  const [reservationEnd, setReservationEnd] = useState('')
  const [schedule, setSchedule] = useState([])
  const [schedule1, setSchedule1] = useState([])
  const [schedule2, setSchedule2] = useState([])
  const [slotDisplay,setSlotDisplay] = useState(false)
  const [calendar, setCalendar] = useState('schedule1')
  const [calendarData, setCalendarData] = useState()
  const startDaysOfTheWeekList = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat']
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  function isEmpty(x) {
    for (const prop in x) {
      if (Object.hasOwn(x, prop)) {
        return false;
      }
    }
    return true;
  }
  function getDaysInMonthUTC(m, y) {
    var date = new Date(Date.UTC(y, m, 1))
    var startDaysOfTheWeek = ''
    var d = []
    while (date.getUTCMonth() === m) {
      if(startDaysOfTheWeek==''){
        startDaysOfTheWeek =new Date(date).toString().slice(0,3)
        if(startDaysOfTheWeek=='Mon'){
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Tue'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Wed'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Thu'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Fri'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Sat'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -5))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }
      }
      d.push(join(new Date(date), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
      date.setUTCDate(date.getUTCDate() + 1)
    }
    return d
  }
  const onClick2CreateScheduleMenu = async()=>{
    setMsg('')
    setErr('')
    setStoreName('')
    setVehicleName('')
    setDate('')
    setTime('')
    setCalendar('schedule1')
    try {
      const { data: res } = await axios.get(`${APIURL}/basic/book-demo-drive2`)
      setReservation_data1(res.info)
    } catch (err) {
      console.log(err)
    }
    setDemoScheduleDisplay(true)
  }  
  const onChange2StoreName = (x1) => { 
    setStoreName(x1)
    setVehicleName('')
    setDate('')
    setTime('')
    const reservation_start = reservation_data1.filter(x=>x.title==x1)[0].reservation_start
    const reservation_end = reservation_data1.filter(x=>x.title==x1)[0].reservation_end
    setReservationStart(reservation_start)
    setReservationEnd(reservation_end)
    const cars = reservation_data1.filter(x=>x.title==x1)[0].demo_drive[0].car.map(x=>x.name)
    let reservation_timesheet1 = {}
    for(let i1=0;i1<cars.length;i1++){
      const reservation_timesheet2 = {}
      let last_date = false
      let i2 = 0
      while(!last_date){
        const timestamp = new Date(`${reservation_start.slice(5,7)}/${reservation_start.slice(8,10)}/${reservation_start.slice(0,4)}`).getTime()+(1000*60*60*24*i2)
        const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
        if(format==reservation_end){
          last_date = true
        }else{
          i2++
        }
        reservation_timesheet2[`${format}`] = [{"10.00-10.30":"F"},{"11.00-11.30":"F"},{"12.00-12.30":"F"},{"13.00-13.30":"F"},{"14.00-14.30":"F"},{"15.00-15.30":"F"},{"16.00-16.30":"F"},{"17.00-17.30":"F"}]
      }         
      let reservation_data2 = ''
      let x2 = reservation_data1.filter(x=>x.title==x1)[0].demo_drive[0].car.filter(x=>x.name==cars[i1])[0].reservation
      if(!isEmpty(x2)){
        reservation_data2 =x2
        for(let i3 = 0; i3<Object.keys(reservation_data2).length;i3++){
          let dataset = [{"10.00-10.30":"F"},{"11.00-11.30":"F"},{"12.00-12.30":"F"},{"13.00-13.30":"F"},{"14.00-14.30":"F"},{"15.00-15.30":"F"},{"16.00-16.30":"F"},{"17.00-17.30":"F"}]
          for(let i4 = 0; i4<Object.values(reservation_data2)[i3].length;i4++){
            const x3 = Object.keys(Object.values(reservation_data2)[i3][i4])[0]
            switch (x3) {
              case '10.00-10.30':
                dataset[0]={"10.00-10.30":"T"}
                break
              case '11.00-11.30':
                dataset[1]={"11.00-11.30":"T"}
                break
              case '12.00-12.30':
                dataset[2]={"12.00-12.30":"T"}
                break
                case '13.00-13.30':
                dataset[3]={"13.00-13.30":"T"}
                break
              case '14.00-14.30':
                dataset[4]={"14.00-14.30":"T"}
                break
              case '15.00-15.30':
                dataset[5]={"15.00-15.30":"T"}
                break
              case '16.00-16.30':
                dataset[6]={"16.00-16.30":"T"}
                break
              case '17.00-17.30':
                dataset[7]={"17.00-17.30":"T"}
                break
              default:
                console.log('out of regular slot')
            }
          }
          reservation_timesheet2[Object.keys(reservation_data2)[i3]]=dataset
        }
      }else{
        console.log('no reservation')
      }
    reservation_timesheet1[cars[i1]] = reservation_timesheet2
    }
    setSchedule(reservation_timesheet1)
    setCalendarData(getDaysInMonthUTC(join(new Date(), [{month: 'numeric'}])-1,join(new Date(), [{year: 'numeric'}])))
    setSchedule1(getDaysInMonthUTC(join(new Date(), [{month: 'numeric'}])-1,join(new Date(), [{year: 'numeric'}])))
    setSchedule2(getDaysInMonthUTC(Number(join(new Date(), [{month: 'numeric'}])),join(new Date(), [{year: 'numeric'}])))
  }
  const onChange2VehicleName = (x1) => { 
    setDate('')
    setTime('')
    setVehicleName(x1)
  }
  const onChange2Date = (e) => { 
      setDate(e.target.value)
      setTime('')
  } 
  const onClick2Date = (x) => { 
   if(new Date(x).getMonth()==new Date(calendarData[15]).getMonth()&&new Date(x).getTime()>=new Date(reservationStart).getTime()&&new Date(x).getTime()<=new Date(reservationEnd).getTime()){
     setDate(x)
   }
  } 
  const onClick2SwicthToSchedule1 =()=>{
    setCalendar('schedule1')
    setCalendarData(schedule1)
  }
  const onClick2SwicthToSchedule2 =()=>{
    setCalendar('schedule2')
    setCalendarData(schedule2)
  }
  const onClick2ReserveDemoDrive = async()=>{
    setErr('')
    setMsg('')
    const date_timestamp = new Date(`${date.slice(5,7)}/${date.slice(8,10)}/${date.slice(0,4)}`).getTime()
    if(date==''){
      setErr('Please select reservation date.')
    }else if(time==''){
      setErr('Please select reservation time.')
    }else{
      const a1 = reservation_data1.findIndex((x) => x.title == storeName)
      const a2 = reservation_data1[a1].demo_drive[0].car.findIndex(x=>x.name==vehicleName)
      let a3 = reservation_data1[a1].demo_drive[0].car[a2].reservation[`${date}`]
      if(a3!=undefined){
        let format = schedule[`${vehicleName}`][`${date}`]
        let a4 = {}
        a4[`${time}`]="T"
        format[format.findIndex((x) => Object.keys(x) == time)]=a4
        reservation_data1[a1].demo_drive[0].car[a2].reservation[`${date}`]=format.filter((x)=>Object.values(x)!="F")
      }else{
        console.log('no existed items')
        let a5 = []
        let a6 ={}
        a6[`${time}`] = "T"
        a5.push(a6)
        reservation_data1[a1].demo_drive[0].car[a2].reservation[`${date}`]=a5
      }
      function timeConverter(x){
        return new Date(`${x.slice(5,7)}/${x.slice(8,10)}/${x.slice(0,4)}`).getTime()
      }
      const a7 = reservation_data1[a1].demo_drive[0].car[a2].reservation
      const a8 = Object.keys(a7).sort((a, b) => {
        return timeConverter(a) - timeConverter(b)
      })
      let a9 = {}
      for(var i1=0; i1<a8.length;i1++){
        a9[a8[i1]]=a7[a8[i1]]
      }
      reservation_data1[a1].demo_drive[0].car[a2].reservation=a9
      try {
        const { data: res } = await axios.post(`${APIURL}/basic/book-demo-drive2`,{'reservation_data':reservation_data1})
        console.log(res)
      } catch (err) {
        console.log(err)
      }
      setMsg(`You are successfully submitted. Your interview is on ${new Date(date_timestamp).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} at ${time.toString().slice(0,5)}.`)
      setDemoScheduleDisplay(false)
    }
  }
  return (
      <div>
      <button className='text-xs primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={demoScheduleDisplay}>Set demo drive time</button>
      {demoScheduleDisplay?<>
      <div className='flex mt-4'>
        <FormControl sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
        <InputLabel sx={{ fontSize:12 }}>Store</InputLabel>
        <Select
          value={storeName}
          label='store_name'
          onChange={(e)=>onChange2StoreName(e.target.value)}
          sx={{ fontSize:9, borderRadius: 0 }}
          error={err!=''&&storeName==''}
        >
          {reservation_data1.map((x)=><MenuItem value={x.title} sx={{fontSize:9}}>{x.title}</MenuItem>)}
        </Select>
      </FormControl>
      {storeName!=''?
      <FormControl  sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
          <InputLabel  sx={{ fontSize:12 }}>Vehicle</InputLabel>
          <Select
            value={vehicleName}
            label='store_name'
            onChange={(e)=>onChange2VehicleName(e.target.value)} 
            sx={{ fontSize:9, borderRadius: 0 }}
            error={err!=''&&vehicleName==''}
          >
            {reservation_data1.filter((x)=>x.title == storeName)[0].demo_drive[0].car.map(x=><MenuItem value={x.name} sx={{fontSize:9}}>{x.name}</MenuItem>)}
          </Select>
        </FormControl>
      : <FormControl  sx={{ mr:1, width: 120, fontSize:14 }} size='small'>
      <InputLabel sx={{ fontSize:12 }}>Vehicle</InputLabel>
      <Select
        value={storeName}
        label='store_name'
        onChange={(e)=>onChange2VehicleName(e.target.value)} 
        sx={{ fontSize:9, borderRadius: 0 }}
      >
      </Select>
    </FormControl>} 
      <input type='date' name='reservation_date' value={date} 
      min={reservationStart} max={reservationEnd} 
      onChange={(x)=>onChange2Date(x)} 
      className={`${err!=''&& date!=''?'border-red-600':'border-[#cbcbcb]'} pr-2 pl-2 text-[9px] border w-fit mr-1 mt-auto h-[30px]`}/>
      </div>
       {storeName!=''?<div className='w-fit mt-4 text-xs flex flex-col'><div className='w-fit'>
      <div className='flex'>
      <div className='flex flex-col mr-4'>
      <div className='flex justify-between mb-1'><MdArrowLeft className={`${calendar=='schedule1'?'invisible':''} mt-auto mb-auto`} onClick={()=>onClick2SwicthToSchedule1()}/><span className='mt-auto mb-auto'>{calendarData[15].slice(5,7)}</span><MdArrowRight  className={`${calendar=='schedule2'?'invisible':''} mt-auto mb-auto`} onClick={()=>onClick2SwicthToSchedule2()}/></div>
      <div className='flex'>{startDaysOfTheWeekList.map(x=><div className='text-center text-[8px] w-[28px]'>{x}</div>)}</div>
      <div className='grid grid-cols-7'>
      {calendarData.map((x)=><div className='text-center text-[8px] w-[28px]'><span className={`
      ${new Date(x).getMonth()<new Date(calendarData[15]).getMonth()&&new Date(x).getTime()<new Date(reservationStart).getTime()?'text-gray-200':''} ${new Date(x).getMonth()<new Date(calendarData[15]).getMonth()&&new Date(x).getTime()>new Date(reservationEnd).getTime()?'text-gray-200':''} ${new Date(x).getMonth()!=new Date(calendarData[15]).getMonth()&&new Date(x).getTime()>=new Date(reservationStart).getTime()&&new Date(x).getTime()<=new Date(reservationEnd).getTime()?'text-gray-400':''} ${new Date(x).getMonth()==new Date(calendarData[15]).getMonth() && new Date(x).getTime()<new Date(reservationStart).getTime()?'text-gray-300':''}  ${new Date(x).getMonth()==new Date(calendarData[15]).getMonth()&&new Date(x).getTime()>new Date(reservationEnd).getTime()?'text-gray-300':''}  ${new Date(x).getMonth()==new Date(calendarData[15]).getMonth()&&new Date(x).getTime()>=new Date(reservationStart).getTime()&&new Date(x).getTime()<=new Date(reservationEnd).getTime()?'text-gray-900 hover:rounded-[100px] hover:bg-gray-100':''} ${x==date?'font-bold':''}
      p-1 cursor-default`} onClick={()=>onClick2Date(x)}>{x.slice(x.length-2,x.length)}
      </span></div>)}
      </div>  
      </div>
      <div className='flex flex-col'>
      <div className='mt-[24px]'>
      <div className='flex'>
        <div className='flex flex-col'>
        {storeName!='' && vehicleName!='' && date!=''?<>{schedule[vehicleName][date].map(x2=>Object.values(x2)).join('').includes('F')?'':<span className='text-xs text-red-700'>All booked for this day. Try another date.</span>}
        {schedule[vehicleName][date].map(x2=><>{Object.values(x2)!='T'?<div id={Object.keys(x2)} className={`text-[8px] border border-gray-200 w-[68px] ml-auto mr-auto rounded-sm text-gray-300 pl-1 pr-1 mb-1 mr-1 cursor-default hover:bg-gray-100 ${time!=Object.keys(x2)[0]?'':'font-bold text-gray-900 bg-gray-100'}`} name={date} value='T' onClick={()=>setTime(Object.keys(x2)[0])}> {Object.keys(x2)}</div>:''}</>)}</>:''}
        </div>
        <div className='relative w-[500px] h-[180px]'><img src={`${vehicleName=='CAR A'?Car1:vehicleName=='CAR B'?Car2:Car3}`} className='car w-[270px]'/>
        </div>
      </div>
      </div>
      </div>
      </div>
      </div>  
      </div>  
      :''}
      <p className='mt-4 mb-1'>Your meeting time:</p>
      <div className='mr-1'>{date} {time}</div>
      {err!='' ? <span className='text-xs text-red-700'>{err}</span>:''}
      <div className='flex mt-4'>
      <div className='primary-btn text-xs w-fit mt-1 mr-1' onClick={()=>setDemoScheduleDisplay(!demoScheduleDisplay)}>Cancel</div>
      <button className='primary-btn text-xs w-fit mt-1' onClick={onClick2ReserveDemoDrive}>Submit</button>
      </div>
      </>:''}<br/>
      {msg!='' ? <>
      <span className='text-xs'>{msg}</span><br/>
      </>:''}
      </div>
  )
}